// extracted by mini-css-extract-plugin
module.exports = {"aboutRelationship":"jgp-35QTx","title":"jgp-hu7Um","description":"jgp-2ftsy"};